import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UeckoUserAdminDTO, UeckoUserDTO } from '../models/user-dto';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';


@Injectable({
  providedIn: 'root'
})

export class UserService {

  private pathAPI = environment.urlAPI;
  private controller = "UeckoUser/";

  public userData = new BehaviorSubject<UeckoUserDTO>(null);

  constructor(private http: HttpClient) { }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });

  }

  public getUserInfo(): Observable<UeckoUserDTO> {
    return this.http.get<UeckoUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  setUserData(user: UeckoUserDTO) {
    this.userData.next(user);
  }

  getUserData(): Observable<UeckoUserDTO> {

    if (this.userData.value != null) {
      return this.userData.asObservable();
    }
    else {
      return this.getUserInfo().pipe(map((userData) => {
        this.userData.next(userData);
        return userData;
      }),
        catchError((err) => {
          return this.userData.asObservable();
        }));
    }
  }

  public get(id: string): Observable<UeckoUserAdminDTO> {
    return this.http.get<UeckoUserAdminDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: UeckoUserAdminDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: UeckoUserAdminDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  public changeLanguage(language: string): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "ChangeLanguage/" + language, null);
  }

}